import { createContext } from "react"

const MultiStepContext = createContext({
    currentStep: 0, // Current step in the multi-step
    setCurrentStep: null, // Set the current step

    library: [], // Array of photos that user uploads
    setLibrary: null, // Set library

    pageContext: {}, // Page context data from gatsby-node

    bLoading: false, // Show loading status of multi-step form
    setBLoading: null, // Method to set bLoading

    lineItem: null, // lineItem object while editing it
    setLineItem: null, // set the line-item
})

export default MultiStepContext;
